import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Leagues from '@/components/Leagues/List'
import LeagueView from '@/components/Leagues/View'
import Competitions from '@/components/Competitions/List'
import CompetitionView from '@/components/Competitions/View'
import Diary from '@/components/Diary/Diary'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
      {
          path: '/leagues',
          name: 'Leagues',
          component: Leagues
      },
      {
          path: '/leagues/view/:id',
          name: 'LeagueView',
          component: LeagueView,
          props:true
      },
      {
          path: '/competitions',
          name: 'Competitions',
          component: Competitions
      },
      {
          path: '/competition/view/:id',
          name: 'CompetitionView',
          component: CompetitionView,
          props:true
      },
      {
          path: '/diary',
          name: 'Diary',
          component: Diary
      },
      {path:'*', redirect:{name:'Home'} },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js